export default __webpack_public_path__ + "4cb8e3937adf6667a5a54aec7aebb6e8.svg";